import {SentactFeedbackError} from "./SentactFeedbackError";

/**
 * Http error class that accepts an error code and message.
 */
export class SentactFeedbackHttpError extends SentactFeedbackError {
    /**
     * constructor
     *
     * @param message  Error message
     * @param code     Error code
     * @param previous Previous error
     */
    constructor (message, code = 500, previous) {
        super(message);
        this.code = code;
        this.previous = previous;
    }
}
